var _linearGradient, _path, _radialGradient, _path2, _linearGradient2, _circle, _linearGradient3, _circle2, _circle3, _linearGradient4, _circle4, _linearGradient5, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "icloud_svg__a",
    x1: 0,
    x2: 24,
    y1: 12,
    y2: 12
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#95dcf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#507eff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.497 10.677A6.508 6.508 0 0014 4a6.513 6.513 0 00-5.68 3.347A3.724 3.724 0 006.75 7c-1.936 0-3.534 1.475-3.725 3.426A5 5 0 000 15c0 2.757 2.243 5 5 5h14.25c2.62 0 4.75-2.13 4.75-4.75a4.73 4.73 0 00-3.503-4.573z",
    fill: "url(#icloud_svg__a)"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    cx: 12.333,
    cy: 19.75,
    gradientUnits: "userSpaceOnUse",
    id: "icloud_svg__b",
    r: 10.198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009ada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e88e5",
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.497 10.677A6.508 6.508 0 0014 4a6.513 6.513 0 00-5.68 3.347A3.724 3.724 0 006.75 7c-1.936 0-3.534 1.475-3.725 3.426A5 5 0 000 15c0 2.757 2.243 5 5 5h14.25c2.62 0 4.75-2.13 4.75-4.75a4.73 4.73 0 00-3.503-4.573z",
    fill: "url(#icloud_svg__b)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "icloud_svg__c",
    x1: 14.944,
    x2: 23.556,
    y1: 13.242,
    y2: 17.258
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.25,
    cy: 15.25,
    fill: "url(#icloud_svg__c)",
    r: 4.75
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "icloud_svg__d",
    x1: 8.594,
    x2: 1.344,
    y1: 12.563,
    y2: 17.48
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.06
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 15,
    fill: "url(#icloud_svg__d)",
    r: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 10.75,
    fill: "#56C7DA",
    opacity: 0.2,
    r: 3.75
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "icloud_svg__e",
    x1: 14,
    x2: 14,
    y1: 4,
    y2: 17
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00accd",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#1ab4d2",
    stopOpacity: 0.175
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5ccadf",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#c5ecf4",
    stopOpacity: 0.041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10.5,
    fill: "url(#icloud_svg__e)",
    r: 6.5
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "icloud_svg__f",
    x1: 2.457,
    x2: 23.088,
    y1: 8.638,
    y2: 18.259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.497 10.677A6.508 6.508 0 0014 4a6.513 6.513 0 00-5.68 3.347A3.724 3.724 0 006.75 7c-1.936 0-3.534 1.475-3.725 3.426A5 5 0 000 15c0 2.757 2.243 5 5 5h14.25c2.62 0 4.75-2.13 4.75-4.75a4.73 4.73 0 00-3.503-4.573z",
    fill: "url(#icloud_svg__f)"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgIcloud as ReactComponent };